<template>
  <div id="loader" class="loader">
    <div class="dot dot1" />
    <div class="dot dot2" />
    <div class="dot dot3" />
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    color: {
      default: '#292929',
      required: false
    }
  }
}
</script>

<style>
.loader {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.loader .dot {
  width: 10px;
  height: 10px;
  background: v-bind(color);
  border-radius: 50%;
  position: absolute;
  top: calc(50% - 5px);
}

.loader .dot1 {
  left: 0px;
  -webkit-animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
  animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
}

.loader .dot2 {
  left: 20px;
  -webkit-animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
  animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
}

.loader .dot3 {
  left: 40px;
  -webkit-animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
  animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
}

@-webkit-keyframes dot-jump {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }

  100% {
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
  }
}

@keyframes dot-jump {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }

  100% {
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
  }
}
</style>
